// Accesos del perfil del usuario en sesión, según apiv2 (GET /v2/profiles/me/accesos).
// No se persiste: el guard del router lo recarga en cada navegación, igual que
// la sesión. Lo consume el getter auth/getUser (usuarioEfectivo).
import ApiService from '@/util/api.service'
import { aplicaPerfil, clavesDeAcceso } from '@/util/accesos-perfil'
import { capasPermitidas } from '@/components/map-v2/data/layer-permissions'

const ESPERA_TRAS_FALLO_MS = 30000
// Instante del último fallo de carga; evita que cada navegación espere un apiv2 caído.
let ultimoFallo = null

const estadoInicial = () => ({
  cargado: false, aplicar: false, perfil: null, accesos: {},
})

const firma = (accesos) => JSON.stringify(
  Object.keys(accesos).sort().map((k) => [k, accesos[k]]),
)

function mismoEstado(s, aplicar, perfil, accesos) {
  if (!s.cargado || s.aplicar !== aplicar) return false
  const a = s.perfil
  if ((a && a.id) !== (perfil && perfil.id) || (a && a.nombre) !== (perfil && perfil.nombre)) return false
  return firma(s.accesos) === firma(accesos)
}

const mutations = {
  SET_ACCESOS(s, { aplicar, perfil, accesos } = {}) {
    const nuevoAplicar = aplicar === true
    const nuevoPerfil = perfil || null
    const nuevosAccesos = accesos || {}
    // La recarga del guard no debe recalcular auth/getUser si nada cambió.
    if (mismoEstado(s, nuevoAplicar, nuevoPerfil, nuevosAccesos)) return
    s.cargado = true
    s.aplicar = nuevoAplicar
    s.perfil = nuevoPerfil
    s.accesos = nuevosAccesos
  },
  RESET_ACCESOS(s) {
    ultimoFallo = null
    Object.assign(s, estadoInicial())
  },
}

const actions = {
  async cargar({ commit }) {
    if (ultimoFallo !== null && Date.now() - ultimoFallo < ESPERA_TRAS_FALLO_MS) return
    try {
      const resp = await ApiService({ url: '/v2/profiles/me/accesos', method: 'get', timeout: 4000 })
      // Sin `aplicar` booleano no es la respuesta de apiv2 (p. ej. el HTML del
      // SPA si nginx no enruta /api/v2): se trata como fallo y no pisa lo bueno.
      if (!resp || typeof resp.aplicar !== 'boolean') throw new Error('Respuesta inválida de /v2/profiles/me/accesos')
      commit('SET_ACCESOS', resp)
      ultimoFallo = null
    } catch (err) {
      // Se conserva el último estado bueno; si nunca cargó, usuarioEfectivo
      // devuelve el usuario tal cual (lo de siempre).
      ultimoFallo = Date.now()
      console.error('No se pudieron cargar los accesos del perfil', { err })
    }
  },
}

export default {
  namespaced: true,
  state: estadoInicial,
  getters: {
    aplicaPerfil: (s) => aplicaPerfil(s),
    clavesDeAcceso: (s) => clavesDeAcceso(s),
    perfil: (s) => s.perfil,
    // Capas del mapa permitidas para el usuario efectivo (única fuente).
    capasPermitidas: (s, _g, _rs, rootGetters) => capasPermitidas(rootGetters['auth/getUser']),
  },
  mutations,
  actions,
}
